
import Vue from 'vue';
import Modal from '@/components/modal/Modal.vue';

export default Vue.extend({
	components: {
		Modal,
	},
	methods: {
		show(): void {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			(this.$refs.modal as any).show();
		},

		hide(): void {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			(this.$refs.modal as any).hide();
		},

		onCancel(): void {
			this.$emit('cancel');
		},

		onConfirm(): void {
			this.$emit('confirm');
		},
	},
});
